module.exports = __webpack_public_path__ + "static/media/question-icon.fe5846b1.png";